export default __webpack_public_path__ + "a0f7fcea8a12f877041944327bc1b018.png";